// src/components/Eventos/EventsHeats/utils/constants.js

// Definición de abreviaturas para la leyenda
export const abbreviationDefinitions = [
    { code: 'PB', meaning: 'Personal Best (Mejor marca personal)' },
    { code: 'SB', meaning: 'Season Best (Mejor marca de la temporada)' },
    { code: 'MR', meaning: 'Meet Record (Récord de la competencia)' },
    { code: 'Q', meaning: 'Clasificado por puesto en Carreras o con la marca de calificación en Concursos' },
    { code: 'q', meaning: 'Clasificado por tiempo en Carreras o por marca en Concursos' },
    { code: 'DNS', meaning: 'Did Not Start (No salió)' },
    { code: 'DNF', meaning: 'Did Not Finish (No terminó la prueba)' },
    { code: 'DQ', meaning: 'Disqualified (Descalificado)' },
    { code: 'NM', meaning: 'No Mark (Sin marca válida registrada)' },
    { code: 'O', meaning: 'Intento Válido en altura y pértiga' },
    { code: 'X', meaning: 'Intento Nulo' },
    { code: '–', meaning: 'Un "pase"' },
    { code: 'r', meaning: 'Abandona la competición (Concursos o Pruebas Combinadas)' },
    { code: 'qR', meaning: 'Pasado a la siguiente ronda por el Juez Árbitro' },
    { code: 'qJ', meaning: 'Pasado a la siguiente ronda por el Jurado de Apelación' },
    { code: 'qD', meaning: 'Pasado a la siguiente ronda por sorteo' },
    { code: '>', meaning: 'Flexión de rodilla (Pruebas de Marcha)' },
    { code: '~', meaning: 'Pérdida de contacto (Pruebas de Marcha)' },
    { code: 'YC', meaning: 'Tarjeta amarilla' },
    { code: 'YRC', meaning: 'Segunda tarjeta amarilla' },
    { code: 'RC', meaning: 'Tarjeta Roja' },
    { code: 'L', meaning: 'Infracción de calle (Reglas 17.3.3 y 17.3.4)' },
    { code: 'P', meaning: 'Participación bajo protesta' },
    { code: 'RT', meaning: 'Reaction Time (Tiempo de reacción)' }
  ];
  
  // Códigos especiales para track y field
  export const SPECIAL_CODES = {
    TRACK: ['DNS', 'DNF', 'DQ', 'SCR', 'FS'],
    FIELD: ['DNS', 'DQ', 'SCR', 'NM', 'X', 'O', 'P', '-']
  };